import { useState, useEffect } from 'react';
import { pdfjs, Document, Page } from 'react-pdf';
import { useNavigate } from 'react-router-dom';
import LoadingSpinner from '../LoadingSpinner';
import styles from './FileDisplayPDF.module.css';

import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export default function FileDisplayPDF(props) {
    const { fileToServe } = props;
    const navigate = useNavigate();
    const [pages, setPages] = useState(null);

    useEffect(() => {
        if (!fileToServe) navigate('/notfound');
    },[fileToServe]);

    const onLoad = ({ numPages }) => {
        setPages(numPages);
    };

    if (!fileToServe) {
        return <div className={styles.display}><LoadingSpinner /></div>;
    };

    return (
        <div className={styles.display}>
            <Document file={`${fileToServe}`} onLoadSuccess={onLoad} loading={<LoadingSpinner />} >
                {Array.from(new Array(pages), (el, index) => (<Page key={`page_${index + 1}`} pageNumber={index + 1} />))}
            </Document>
        </div>
    );
};
